import { render, staticRenderFns } from "./RefundPage.vue?vue&type=template&id=c0abc38a&scoped=true&"
import script from "./RefundPage.vue?vue&type=script&lang=js&"
export * from "./RefundPage.vue?vue&type=script&lang=js&"
import style0 from "./RefundPage.vue?vue&type=style&index=0&id=c0abc38a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0abc38a",
  null
  
)

export default component.exports